<template>
  <div v-loading="loading">

    <div class="pagemain">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px" label-position="left">
        <div class="mm-row">
          <div class="mm-item">
            <el-form-item label="發送給" prop="to">
              <!-- <el-input v-model="form.to" placeholder="可輸入部門或用戶名稱搜尋添加"></el-input> -->
              <el-select v-model="form.to" clearable class="filter" filterable remote reserve-keyword placeholder="可輸入部門或用戶名稱搜尋添加" :remote-method="remoteMethod" :loading="loading">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="mm-row">
          <div class="mm-item">
            <el-form-item label="消息模板">
              <el-select class="elselect" @change="choose_template" v-model="template">
                <el-option label="訂單已修改，請查看" value="訂單已修改，請查看"></el-option>
                <el-option label="訂單有誤，請修改" value="訂單有誤，請修改"></el-option>
              </el-select>
            </el-form-item>

          </div>
        </div>
        <div class="mm-row">
          <div class="mm-item">
            <el-form-item label="消息" prop="content">
              <el-input type="textarea" v-model="form.content"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="mm-row">
          <el-form-item>
            <el-button @click="fromsumbit('form')" type="primary">發送</el-button>

          </el-form-item>
        </div>

      </el-form>
    </div>
  </div>

</template>

<script>
export default {
  name: "sendmessage",
  props: ['ordernum', 'order_id'],
  data () {
    return {
      options: [],
      value: [],
      template: '',
      loading: false,
      form: {
        order_id: 0,
        ordernum: '',
        from_id: 0,
        to: '',
        to_id: 0,
        content: ''

      },
      rules: {
        to: [{
          required: true,
          message: '請填寫發送目標用戶',
        }, {
          pattern: /^[\S]+$/,
          message: '只能輸入可見字符'
        }],
        content: [{
          required: true,
          message: '請添加發送內容',
        }],


      }
    }
  },
  mounted () {
    this.elSelectFocus();
  },
  methods: {
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true;
        let staff_id = sessionStorage.getItem('staff_id');
        this.post('/api/user/get_user_by_name', {
          name: query,
          staff_id: staff_id
        }).then((response) => {
          this.loading = false;
          if (response.status = 'success') {
            this.options = response.data.map(item => {
              return { value: item.username, label: `${item.username}(${item.name})` };
            });
          } else {
            this.options = [];
          }

        }).catch(error => {
          console.log(error);
        });
      } else {
        this.options = [];
      }
    },
    choose_template (content) {
      this.form.content = content;
    },
    fromsumbit (form) {

      this.$refs[form].validate((valid) => {
        if (valid) {
          //this.loading = true;

          this.post('/api/message/checkuser', {
            username: this.form.to
          }).then((check) => {
            if (check.status == 'error') {
              this.$message({
                showClose: true,
                message: '未找到目標用戶',
                type: 'error',

              });
            } else if (check.status == 'success') {
              this.form.to_id = check.user_id;
              let data = this.form;
              this.post('/api/message/addsave', {
                data: data
              }).then((res) => {

                if (res == 'success') {
                  let username = sessionStorage.getItem('username');
                  let thumb = sessionStorage.getItem('thumb');
                  let swoolecontent = {
                    'type': 'message',
                    username: username,
                    thumb: thumb,
                    'content': data.content
                  };
                  this.wssend(this.form.from_id, this.form.to_id, swoolecontent);
                  this.$message({
                    showClose: true,
                    message: '消息發送成功',
                    type: 'success',
                    onClose: (() => {
                      this.$emit('closedialog');
                    })
                  });
                } else {
                  this.$message({
                    showClose: true,
                    message: '消息發送失敗，請重試！',
                    type: 'error',

                  });
                }

                this.loading = false;
              }).catch((err) => {
                this.loading = false;
                console.log(err)
              });
            }
          })

        }
      });
    },
    wssend (from_id, to_id, content) {
      let swoolecontent = JSON.stringify(content);
	  let databasename = localStorage.getItem('databasename');
      let data = {
		databasename:databasename,
        from_id: from_id,
        to_id: to_id,
        content: swoolecontent
      }
      websocket.send(JSON.stringify(data));
    },
  },
  created () {
    this.form.from_id = parseInt(sessionStorage.getItem('user_id'));
    this.form.ordernum = this.ordernum;
    this.form.order_id = this.order_id;
  }




}
</script>

<style>
.el-form-item {
  flex: 1;
}
</style>
